/**
 * The approvals-summary cache key + the one helper every approval
 * decision calls (2026-10 QA fix — "phantom counts").
 *
 * GET /api/v1/approvals/summary feeds the Inbox surface badge, the
 * /approvals tab badges and the Me-home "My queue" rows. Each module's
 * own mutation helper already flushed its list (so a decided row left its
 * panel), but only the delegation hooks flushed the summary — so after an
 * inline approve/reject the panel emptied while the badges kept showing
 * the old count until the 60s staleTime ran out (and longer: the cache is
 * persisted to localStorage).
 *
 * Every module mutation helper that can change what is waiting on
 * someone (a decision, a cancel, a resubmission) calls
 * invalidateApprovalsSummary. lib/approvals-invalidate.test.ts pins that
 * every hook module exporting a decision mutation does.
 *
 * Plain .ts with no runtime imports so the node unit tests can load it.
 */

/** react-query key of GET /api/v1/approvals/summary. */
export const APPROVALS_SUMMARY_QUERY_KEY = ["approvals", "summary"] as const;

/** The slice of QueryClient this helper needs (keeps the module import-free). */
export interface InvalidatingClient {
  invalidateQueries(filters: { queryKey: readonly unknown[] }): Promise<void>;
}

/** Refetch the approvals summary (Inbox badge, /approvals tab badges, My queue). */
export function invalidateApprovalsSummary(qc: InvalidatingClient): void {
  void qc.invalidateQueries({ queryKey: APPROVALS_SUMMARY_QUERY_KEY });
}
